import { BasicProps } from '@eastcoal/common/types/component'

import { MethodBar } from './MethodBar'
import { StatusRibbon } from './StatusRibbon'

export const AuctionDetailBidStatusCard = (props: BasicProps) => {
  return (
    <div {...props}>
      <StatusRibbon />
      <MethodBar />
    </div>
  )
}
